export var RoleManagement;
(function (RoleManagement) {
    RoleManagement["MANUAL"] = "1";
    RoleManagement["HARDEST"] = "2";
    RoleManagement["ALL"] = "3";
})(RoleManagement || (RoleManagement = {}));
